import cx from 'classnames';
import * as React from 'react';

import Text from 'components/Text';

import './styles/DividerText.scss';

// # TODO
// • Reconcile with Divider
// • Deprecate most props

export type DividerTextColor = 'pennant' | 'graphite';
export type DividerTextPosition = 'top' | 'middle' | 'bottom';
export type DividerTextAlign = 'left' | 'right' | 'center';
export type DividerTextWeight = 'thick' | 'thin';

type DefaultProps = {
  color: DividerTextColor;
  dividerPosition: DividerTextPosition;
  weight: DividerTextWeight;
  textAlign: DividerTextAlign;
};

export type Props = {
  children: React.ReactNode;
  className?: string;
  uppercase?: boolean;
} & DefaultProps;

export default class DividerText extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    color: 'graphite',
    dividerPosition: 'middle',
    weight: 'thin',
    textAlign: 'center',
  };

  render() {
    const {
      children,
      className,
      color,
      dividerPosition,
      textAlign,
      uppercase,
      weight,
    } = this.props;

    return (
      <div
        className={cx(
          'DividerText',
          color && `DividerText--${color}`,
          dividerPosition && `DividerText--${dividerPosition}`,
          textAlign && `DividerText--${textAlign}`,
          weight && `DividerText--${weight}`,
          className
        )}>
        <Text size="xxxxsmall" uppercase={uppercase} weight="semibold" className="DividerText-text">
          {children}
        </Text>
      </div>
    );
  }
}
